import React from 'react';

import { useDispatch } from 'react-redux';

import Column from '@amzn/meridian/column';
import DatePicker from '@amzn/meridian/date-picker';
import Text from '@amzn/meridian/text';
import moment from 'moment';
import { setSelectedFilterOptions } from 'src/store/placementOverviewPageSlice';
import { useAppSelector } from 'src/store/store';

const StartAndEndDateInput = () => {
  const dispatch = useDispatch();
  const { selectedFilterOptions } = useAppSelector((state) => state.placementOverviewPage);

  return (
    <Column spacing="400">
      <Column spacing="100">
        <Text>Placement Start Date</Text>
        <DatePicker
          value={moment(selectedFilterOptions.placementStartDate).format('YYYY-MM-DD')}
          onChange={(newValue) => {
            dispatch(
              setSelectedFilterOptions({
                ...selectedFilterOptions,
                placementStartDate: moment(newValue).format('MM/DD/YYYY'),
              }),
            );
          }}
          placeholder="MM/DD/YYYY"
        />
      </Column>
      <Column spacing="100">
        <Text>Placement End Date</Text>
        <DatePicker
          value={moment(selectedFilterOptions.placementEndDate).format('YYYY-MM-DD')}
          onChange={(newValue) => {
            dispatch(
              setSelectedFilterOptions({
                ...selectedFilterOptions,
                placementEndDate: moment(newValue).format('MM/DD/YYYY'),
              }),
            );
          }}
          placeholder="MM/DD/YYYY"
        />
      </Column>
    </Column>
  );
};

export default StartAndEndDateInput;
